//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ValidationErrorList',
  props: {
    errors: {
      type: Array,
      required: false,
      default: null
    }
  }
};